import { Routes, Route, NavLink } from 'react-router-dom';
import { LayoutDashboard, Building2, Layers, Users, ScrollText } from 'lucide-react';
import { TopNav } from '@/components/layout/TopNav';
import { cn } from '@/lib/utils';
import { AdminOverview } from '@/components/admin/AdminOverview';
import { AdminAgencies } from '@/components/admin/AdminAgencies';
import { AdminWorkspaces } from '@/components/admin/AdminWorkspaces';
import { AdminUsers } from '@/components/admin/AdminUsers';
import { AdminAuditLog } from '@/components/admin/AdminAuditLog';

const TABS = [
  { to: '/admin', label: 'Overview', icon: LayoutDashboard, end: true },
  { to: '/admin/agencies', label: 'Agencies', icon: Building2 },
  { to: '/admin/workspaces', label: 'Workspaces', icon: Layers },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/audit', label: 'Audit Log', icon: ScrollText },
];

export function Admin() {
  return (
    <div className="flex-1 overflow-hidden flex flex-col">
      <TopNav title="Platform Admin" description="Superadmin · platform-wide oversight" />

      <div className="flex flex-1 overflow-hidden">
        {/* Admin sidebar */}
        <div className="w-48 border-r border-border py-4 px-2 shrink-0">
          <nav className="space-y-0.5">
            {TABS.map((tab) => (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.end}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-2.5 px-3 py-2 rounded-md text-xs font-medium transition-colors',
                    isActive
                      ? 'bg-accent/10 text-accent'
                      : 'text-muted-foreground hover:text-foreground hover:bg-muted/40'
                  )
                }
              >
                <tab.icon className="h-4 w-4 shrink-0" />
                {tab.label}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Admin content */}
        <div className="flex-1 overflow-y-auto p-6">
          <Routes>
            <Route index element={<AdminOverview />} />
            <Route path="agencies" element={<AdminAgencies />} />
            <Route path="workspaces" element={<AdminWorkspaces />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="audit" element={<AdminAuditLog />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}
